class QuizFunnel extends HTMLElement {
    constructor() {
        super();

        this.tracker = null;
        this.stagesTotal = null;
        this.stagesCountable = null;
        this.progressBarFill = null;
        this.progressBarLabel = null;

        // HYDRATE STATE FROM SESSION STORAGE (Survives Shopify form reloads!)
        this.selectedCollectionHandle = sessionStorage.getItem('quiz-collection-handle') || null;
        this.selectedRecipient = sessionStorage.getItem('quiz-recipient-handle') || null;
        this.selectedColorOption = sessionStorage.getItem('quiz-color-option') || null;
        this.selectedOccasion = sessionStorage.getItem('quiz-occasion-handle') || null;
        this.selectedDelivery = sessionStorage.getItem('quiz-delivery-handle') || null;

        this.selectedAnswerTags = JSON.parse(sessionStorage.getItem('quiz-answer-tags') || '[]');
        this.backupCollectionHandle = 'najprodavanije';
        this.backupColorOption = "925 Sterling Silver";

        // this.progressMap = {
        //     "1": "16",
        //     "2": "32",
        //     "3": "58",
        //     "4": "74",
        //     "5": "90",
        //     "6": "99"
        // }

        this.progressMap = {
            "1": "25",
            "2": "50",
            "3": "75",
            "4": "99",
            "5": "90",
            "6": "99"
        }

        // For Easier updates, code suggestions
        this.backButtonItem = 'back-button';
        this.progressBarItem = 'progress-bar';
        this.stageTrackerItem = 'stage-tracker';

        // All button classes that lead to the next stage
            // Exclusions - Button Reset (last stage), Button Skip To End (customer email stage)
        this.stageButtons = [
            '.quiz-funnel__option', 
            // '.quiz-funnel__delivery',
            '.quiz-funnel__discount-close',
            // '.quiz-funnel__collection-block',
            '.quiz-funnel__button:not(.final):not(.skip):not(.submit):not(.type)', 
        ];

        this.collectionButtons = ['.quiz-funnel__collection-block', '.quiz-funnel__button.type'];
        this.colorOptions = '.quiz-funnel__color';
    }

    connectedCallback() {
        // Container
        this.initializeContainer();

        // Progress
        this.initializeProgress();

        // Stage Buttons
        this.initializeStageButtons();

        // Accordion
        this.initializeAccordions();

        // Discount code
        this.initializeDiscountCode();

        // Final Countdown
        this.initializeCountdown();

        // Toggle first stage or fallback safely to active session stage if refreshed
        this.toggleStage(this.getCurrentStage() || 0);
        // this.toggleStage(this.stagesTotal.length - 1);

        // RESTORE OR ADVANCE STAGE AFTER FORM SUBMISSION
        this.initializeCustomerForm();
    }

    // Initialize container size
    initializeContainer() {
        const head = this.querySelector('.quiz-funnel__head');
        // const body = this.querySelector('.quiz-funnel__body');
        const progress = this.querySelector('.quiz-funnel__progress');

        // if(!head || !body) return;
        
        // const value = head.getBoundingClientRect().height;
        // body.style.height = `calc(100vh - ${value}px)`;
    
        if(head) {
            this.style.setProperty(
                '--quiz-header-height',
                `${head.getBoundingClientRect().height}px`
            );
        }

        if(progress) {
            this.style.setProperty(
                '--quiz-progress-height',
                `${progress.getBoundingClientRect().height}px`
            );
        }
    }

    // Initialize progress components
        // Total stages
        // Total query stages - if the user makes a decision/selection
        // Stage Tracker
        // Progress bar fill
        // Progress bar label
    initializeProgress() {
        this.tracker = this.querySelector('.quiz-funnel__tracker');
        this.stagesTotal = this.querySelectorAll('.quiz-funnel__stage');
        this.stagesCountable = this.querySelectorAll('.quiz-funnel__stage.countable');
        this.progressBarFill = this.querySelector('.quiz-funnel__progress-bar--fill');
        this.progressBarLabel = this.querySelector('.quiz-funnel__progress-bar-label');

        if(!this.stagesCountable.length) return;

        this.updateProgressTracking();
    }

    // Initialize buttons
        // Reset Quit
        // Next Stage
        // Previous Stage
        // Skip to end

    getAnswerTag(button) {
        if (!button) return null;

        const tag = button.getAttribute('data-answer-tag');

        if (tag && tag.trim()) {
            return tag.trim();
        }

        return button.textContent.trim().replace(/\s+/g, ' ');
    }

    saveAnswerTag(button) {
        const tag = this.getAnswerTag(button);

        if (!tag) return;

        if (!this.selectedAnswerTags.includes(tag)) {
            this.selectedAnswerTags.push(tag);
        }

        sessionStorage.setItem('quiz-answer-tags', JSON.stringify(this.selectedAnswerTags));
        this.syncCustomerTagsInput();
    }

    syncCustomerTagsInput() {
        const input = this.querySelector('#quiz-funnel__customer-tags');

        if (!input) return;

        const tags = ['kviz', ...this.selectedAnswerTags];

        input.value = [...new Set(tags)].join(',');
    }

    initializeStageButtons() {
        const buttons = this.querySelectorAll(this.stageButtons.join(','));
        const buttonPrevious = this.querySelector('.quiz-funnel__prev');
        const buttonSubmit = this.querySelector('.quiz-funnel__button.submit');
        const buttonSkipToEnd = this.querySelector('.quiz-funnel__button.skip');
        const buttonResetQuiz = this.querySelector('.quiz-funnel__button.final');
        
        const collectionButtons = this.querySelectorAll(this.collectionButtons.join(','));
        const colorOptions = this.querySelectorAll(this.colorOptions);

        if(buttonResetQuiz) buttonResetQuiz.addEventListener('click', () => this.goToStage(0));
        if(buttonPrevious) buttonPrevious.addEventListener('click', () => this.updateStageProgress(-1));
        
        if(buttonSkipToEnd) buttonSkipToEnd.addEventListener('click', () => {
            sessionStorage.removeItem('is_subscribed');
            this.goToStage(this.stagesTotal.length - 1);
        });
        
        if (buttons.length) {
            buttons.forEach(button => button.addEventListener('click', () => {
                const currentStage = this.getCurrentStage();

                // Clear out stale tags from this stage if a user came back to change their mind
                const oldButtonInStage = this.stagesTotal[currentStage].querySelector('.quiz-funnel__option[data-chosen="true"], .quiz-funnel__button[data-chosen="true"]');
                if (oldButtonInStage) {
                    const oldTag = this.getAnswerTag(oldButtonInStage);
                    this.selectedAnswerTags = this.selectedAnswerTags.filter(t => t !== oldTag);
                    oldButtonInStage.removeAttribute('data-chosen');
                }

                // Extract and normalize string options safely
                const rawSelection = button.getAttribute('data-answer-tag') || button.textContent;
                const normalizedSelection = this.sanitizeHandle(rawSelection);

                // Explicitly manage step-by-step updates on every click
                if (button.classList.contains('recipient')) {
                    this.selectedRecipient = normalizedSelection;
                    sessionStorage.setItem('quiz-recipient-handle', this.selectedRecipient);
                } else if (this.stagesTotal[currentStage].querySelector('.recipient')) {
                    this.selectedRecipient = null;
                    sessionStorage.removeItem('quiz-recipient-handle');
                }

                if (button.classList.contains('occasion')) {
                    this.selectedOccasion = normalizedSelection;
                    sessionStorage.setItem('quiz-occasion-handle', this.selectedOccasion);
                } else if (this.stagesTotal[currentStage].querySelector('.occasion')) {
                    this.selectedOccasion = null;
                    sessionStorage.removeItem('quiz-occasion-handle');
                }

                if (button.classList.contains('rush')) {
                    this.selectedDelivery = normalizedSelection;
                    sessionStorage.setItem('quiz-delivery-handle', this.selectedDelivery);
                } else if (this.stagesTotal[currentStage].querySelector('.rush')) {
                    this.selectedDelivery = null;
                    sessionStorage.removeItem('quiz-delivery-handle');
                }

                // Mark this button as chosen so we know to strip its tag if they back up later
                button.setAttribute('data-chosen', 'true');

                this.saveAnswerTag(button);
                this.updateStageProgress(1);
            }));
        }

        if (collectionButtons.length) {
            collectionButtons.forEach(button => button.addEventListener('click', () => {
                const currentStage = this.getCurrentStage();
                
                // Clean up previous collection button tags from this stage
                const oldCollButton = this.stagesTotal[currentStage].querySelector('.quiz-funnel__collection-block[data-chosen="true"], .quiz-funnel__button.type[data-chosen="true"]');
                if (oldCollButton) {
                    const oldTag = this.getAnswerTag(oldCollButton);
                    this.selectedAnswerTags = this.selectedAnswerTags.filter(t => t !== oldTag);
                    oldCollButton.removeAttribute('data-chosen');
                }

                this.selectedCollectionHandle = button.getAttribute('data-collection-handle');
                sessionStorage.setItem('quiz-collection-handle', this.selectedCollectionHandle);

                button.setAttribute('data-chosen', 'true');
                this.saveAnswerTag(button);
                this.updateStageProgress(1);
            }));
        }

        if (colorOptions.length) {
            colorOptions.forEach(option => option.addEventListener('click', () => {
                const currentStage = this.getCurrentStage();
                
                // Clean up previous color options tags from this stage
                const oldColorOption = this.stagesTotal[currentStage].querySelector('.quiz-funnel__color[data-chosen="true"]');
                if (oldColorOption) {
                    const oldTag = this.getAnswerTag(oldColorOption);
                    this.selectedAnswerTags = this.selectedAnswerTags.filter(t => t !== oldTag);
                    oldColorOption.removeAttribute('data-chosen');
                }

                this.selectedColorOption = option.getAttribute('data-color-option');
                sessionStorage.setItem('quiz-color-option', this.selectedColorOption);

                option.setAttribute('data-chosen', 'true');
                this.saveAnswerTag(option);
                this.updateStageProgress(1);
            }));
        }
    }

    // Initialize accordions
    initializeAccordions() {
        const accordions = this.querySelectorAll('.quiz-funnel__subpotions');
        if(!accordions.length) return;

        accordions.forEach(accordion => {
            const head = accordion.querySelector('.quiz-funnel__suboptions-head');
            const body = accordion.querySelector('.quiz-funnel__suboptions-body');
            if(!head || !body) return;

            head.addEventListener('click', () => {
                const state = accordion.getAttribute('aria-expanded') === 'true';
                accordion.setAttribute('aria-expanded', !state);
                body.setAttribute('aria-expanded', !state);
            });
        });
    }

    sanitizeHandle(text) {
        if (!text) return '';
        return text
            .toLowerCase()
            .trim()
            .replace(/đ/g, 'd') // Custom map for Serbian cross-bar d
            .normalize("NFD")    // Decomposes combined characters (e.g., č -> c + ˇ)
            .replace(/[\u0300-\u036f]/g, "") // Strips the accent marks away
            .replace(/\s+/g, '-') // Converts remaining spaces to clean URL hyphens
            .replace(/[^a-z0-9\-]/g, ''); // Safety scrub for punctuation
    }

    // Initialize final countdown
    initializeCountdown() {
        const countdown = this.querySelector('.quiz-funnel__countdown-text');
        if(!countdown) return;

        // 1. Define 15 minutes in milliseconds and set the target end time
        const FIFTEEN_MINUTES = 15 * 60 * 1000;
        const targetTime = Date.now() + FIFTEEN_MINUTES;

        const updateCountdown = () => {
            const now = Date.now();
            let difference = targetTime - now;

            // 2. If the timer hits zero, clear the interval and lock it at 0
            if (difference <= 0) {
                difference = 0;
                clearInterval(this.countdownInterval);
            }

            // 3. Keep your existing math and structure intact
            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((difference % (1000 * 60)) / 1000);

            const formatted = `
                <span class="quiz-funnel__countdown-time">
                    ${String(hours).padStart(2, '0')}h :
                    ${String(minutes).padStart(2, '0')}min :
                    ${String(seconds).padStart(2, '0')}sec
                </span>
            `;

            countdown.innerHTML = countdown.dataset.text.replace('{time}', formatted);
        };

        countdown.dataset.text = countdown.textContent;

        // 4. Run immediately and save the interval instance to the component class
        updateCountdown();
        this.countdownInterval = setInterval(updateCountdown, 1000);
    }

    // Initialize discount code
        // when the user clicks the button, copy the code to the clipboard
    initializeDiscountCode() {
        const button = this.querySelector('.quiz-funnel__discount-copy');
        const discount = this.querySelector('.quiz-funnel__discount-code');

        if(!button || !discount) return;

        button.addEventListener('click', async () => {
            const code = discount.textContent.trim();

            try {
                await navigator.clipboard.writeText(code);
                button.textContent = "Kod Kopiran";
            } catch(error) {
                console.error('Failed to copy discount code: ', error);
            }
        });
    }

    // Initialize customer form
        // Track successful Shopify submission
        // Add subscribed state class
    initializeCustomerForm() {
        const form = this.querySelector('#quiz-funnel__customer-form');

        if (!form) return;

        const submissionFlag = 'quiz-funnel-customer-form-submitted';
        const restoreFlag = 'quiz-funnel-restore-final';
        const restoreExpiresFlag = 'quiz-funnel-restore-final-expires';

        const RESTORE_TTL = 5 * 60 * 1000; // 5 minutes

        const setFinalRestoreFlag = () => {
            sessionStorage.setItem(restoreFlag, 'true');
            sessionStorage.setItem(restoreExpiresFlag, String(Date.now() + RESTORE_TTL));
        };

        const shouldRestoreFinal = () => {
            const expiresAt = Number(sessionStorage.getItem(restoreExpiresFlag) || 0);

            return (
                sessionStorage.getItem(restoreFlag) === 'true' &&
                expiresAt > Date.now()
            );
        };

        const goToFinalStage = () => {
            sessionStorage.setItem('is_subscribed', 'true');
            this.classList.add('is-subscribed');

            const finalStage = this.querySelector('.quiz-funnel__stage.final');
            const finalStageIndex = Array.from(this.stagesTotal).indexOf(finalStage);

            if (finalStageIndex !== -1) {
                this.goToStage(finalStageIndex);
                return;
            }

            const formStage = form.closest('.quiz-funnel__stage');
            const formStageIndex = Array.from(this.stagesTotal).indexOf(formStage);

            if (formStageIndex !== -1) {
                this.goToStage(Math.min(formStageIndex + 1, this.stagesTotal.length - 1));
            }
        };

        // Before submit → store current state
        form.addEventListener('submit', () => {
            this.syncCustomerTagsInput();

            const formStage = form.closest('.quiz-funnel__stage');
            const formStageIndex = Array.from(this.stagesTotal).indexOf(formStage);

            sessionStorage.setItem(
                'quiz-funnel-stage',
                formStageIndex !== -1 ? formStageIndex : this.getCurrentStage()
            );

            sessionStorage.setItem(submissionFlag, 'true');
        });

        // Handle Shopify Redirects / Reloads
        const params = new URLSearchParams(window.location.search);
        const hasErrors = form.querySelector('.errors');

        const hasCustomerPostedParam = params.get('customer_posted') === 'true';
        const hasCustomerFormHash = window.location.hash === '#quiz-funnel__customer-form';
        const hasPendingSubmission = sessionStorage.getItem(submissionFlag) === 'true';

        const isSuccessfulSubmission =
            !hasErrors &&
            (
                hasCustomerPostedParam ||
                (hasCustomerFormHash && hasPendingSubmission)
            );

        // CASE A: Successful submission
        if (isSuccessfulSubmission) {
            /*
                Important:
                Keep a temporary restore flag because Intelligems/Shopify can still
                re-render or navigate once more after this logic runs.
            */
            setFinalRestoreFlag();
            goToFinalStage();

            sessionStorage.removeItem('quiz-funnel-stage');
            sessionStorage.removeItem(submissionFlag);

            /*
                Do NOT clean the URL here.

                The immediate history.replaceState cleanup is likely what you are
                seeing as the page going back to /pages/pronadji-poklon.
                Let the restore flag handle any extra redirect/re-render first.
            */
            return;
        }

        // CASE B: Extra Intelligems / Shopify return after successful submit
        if (!hasErrors && shouldRestoreFinal()) {
            goToFinalStage();
            return;
        }

        // CASE C: Failed submission, show error state
        if (hasErrors) {
            sessionStorage.removeItem(submissionFlag);
            sessionStorage.removeItem(restoreFlag);
            sessionStorage.removeItem(restoreExpiresFlag);

            const formStage = form.closest('.quiz-funnel__stage');
            const stageIndex = Array.from(this.stagesTotal).indexOf(formStage);
            
            if (stageIndex !== -1) {
                this.goToStage(stageIndex);
            }
        }
    }

    // Update the component
        // Get current stage
        // Update progress bar & tracking
        // Toggle/Hide progress bar/ tracking elements if necessary
    updateProgressTracking() {
        const currentStage = this.getCurrentStage();
        if(!currentStage && currentStage != 0) return;

        this.tracker.innerHTML = `${currentStage}/${this.stagesCountable.length}`;

        // const currentProgress = (currentStage / this.stagesCountable.length) * 100;
        // this.progressBarFill.style.setProperty('--fill', `${currentProgress}%`);
        // this.progressBarLabel.innerHTML = `${Math.round(currentProgress)}%`;
        
        const currentProgress = this.progressMap[currentStage] || 0;

        this.progressBarFill.style.setProperty('--fill', `${currentProgress}%`);
        this.progressBarLabel.innerHTML = `${currentProgress}%`;

        if(currentStage > 0) this.toggleElement(this.backButtonItem, true);
        else this.toggleElement(this.backButtonItem, false);

        if(currentStage > 0 && currentStage <= this.stagesCountable.length) this.toggleElement(this.stageTrackerItem, true);
        else this.toggleElement(this.stageTrackerItem, false);

        if(currentStage > 0 && currentStage <= this.stagesCountable.length) this.toggleElement(this.progressBarItem, true);
        else this.toggleElement(this.progressBarItem, false);
    }

    // Go to the next/prev stage depending on input
    updateStageProgress(step) {
        const currentStage = this.getCurrentStage();
        if(!currentStage && currentStage != 0) return;

        let nextStage = currentStage + step;

        if(!this.isSubscribed() && this.isNextDiscount(nextStage)) nextStage += step; 

        // console.log("Current Stage: ", currentStage);
        // console.log("Next Stage: ", nextStage);

        if(nextStage < 0) nextStage = 0;
        if(nextStage > this.stagesTotal.length) nextStage = this.stagesTotal.length;

        this.setAttribute('data-current-stage', nextStage);

        this.updateProgressTracking();
        this.toggleStage(nextStage);
    }

    // Hide all stages, show the one @index
    toggleStage(index) {
        this.stagesTotal.forEach(stage => stage.classList.remove('active'));
        const activeStage = this.stagesTotal[index];
        
        if (activeStage) {
            activeStage.classList.add('active');

            // INTERCEPT ENTRY INTO THE FINAL STEP CONTAINER (Fires via skip or post-redirect)
            if (activeStage.classList.contains('final')) {
                this.loadDynamicResults();
            }
        }
    }

    // Isolated fetch engine to easily handle main rendering and fallback retries
    async fetchCollectionHTML(collection, color) {
        const endpointUrl = new URL(`/collections/${collection}`, window.location.origin);
        
        const recipient = this.selectedRecipient || sessionStorage.getItem('quiz-recipient-handle');
        const sectionId = (recipient === 'za-mamu' || recipient === 'za-baku') ? 'quiz-results-alternate' : 'quiz-results-renderer';
        
        endpointUrl.searchParams.set('section_id', sectionId);
        endpointUrl.searchParams.set('_ts', Date.now()); // <-- FIX: Force cache-busting on every fetch execution loop
        
        if (recipient) {
            endpointUrl.searchParams.set('view_recipient', recipient); 
        }

        if (color && color !== "925 Sterling Silver") {
            endpointUrl.searchParams.set('filter.v.option.color', color);
            endpointUrl.searchParams.set('filter.v.availability', '1');
        }

        if (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) {
            endpointUrl.searchParams.set('preview_theme_id', window.Shopify.theme.id);
        }

        const response = await fetch(endpointUrl.toString());
        if (!response.ok) {
            throw new Error(`Shopify API responded with status ${response.status}.`);
        }
        
        return await response.text();
    }

    // Async Fetch Engine: Loads filtered collection blocks using Shopify Section Rendering API
    async loadDynamicResults() {
        const container = this.querySelector('#quiz-dynamic-products-container');
        if (!container) return;

        // Fallback layout checks: checks runtime variables first, then reads from session storage
        let collection = this.selectedCollectionHandle || sessionStorage.getItem('quiz-collection-handle');
        const color = this.selectedColorOption || sessionStorage.getItem('quiz-color-option');

        if (!collection) {
            container.innerHTML = '<p class="quiz-funnel__error">Greška: Kolekcija nije izabrana. Molimo pokrenite kviz ponovo.</p>';
            return;
        }

        // Show loading template gracefully during asynchronous retrieval
        container.innerHTML = '<div class="quiz-funnel__loading">Pronaći ćemo savršen nakit za Vas...</div>';

        try {
            // Fetch primary collection selections
            let renderHTML = await this.fetchCollectionHTML(collection, color);

            // REQUIREMENT 1: Parse string response to check for empty states safely in memory
            const parser = new DOMParser();
            let parsedDoc = parser.parseFromString(renderHTML, 'text/html');
            const hasNoResults = parsedDoc.querySelector('.quiz-funnel__no-results') !== null;

            // Trigger fallback if primary yields nothing and we aren't already looking at the backup
            if (hasNoResults && collection !== this.backupCollectionHandle) {
                console.warn(`No active inventory found for ${color} in '${collection}'. Trying fallback: '${this.backupCollectionHandle}'`);
                collection = this.backupCollectionHandle;
                renderHTML = await this.fetchCollectionHTML(collection, color);
            }
            
            container.innerHTML = renderHTML;

            // TELEPORT FIX: Grab the poster element from the outer template and append it to the dynamic results
            const posterTemplate = document.getElementById('QuizPosterTemplate');
            if (posterTemplate) {
                // Clone the content of the template tag 
                const containerBlocks = container.querySelector('#shopify-section-quiz-results-renderer');
                const containerBlocksAlternate = container.querySelector('#shopify-section-quiz-results-alternate');
                const noResults = container.querySelector('.quiz-funnel__no-results');

                const posterClone = posterTemplate.content.cloneNode(true);

                if(containerBlocks && !noResults) containerBlocks.appendChild(posterClone);
                if(containerBlocksAlternate && !noResults) containerBlocksAlternate.appendChild(posterClone);
            }

        } catch (error) {
            console.error('Quiz Core Exception:', error);
            container.innerHTML = '<p class="quiz-funnel__error">Došlo je do greške prilikom učitavanja. Pogledajte konzolu za detalje.</p>';
        }
    }

    // Toggle visibility of tracking elements
    toggleElement(element, state) {
        let controlClass = "";
        if(element === 'back-button') controlClass = 'hide-back-button'
        else if(element === 'progress-bar') controlClass = 'hide-progress-bar'
        else if(element === 'stage-tracker') controlClass = 'hide-stage-tracker'

        if(state) this.classList.remove(controlClass);
        else this.classList.add(controlClass);
    }

    isSubscribed() {
        // console.log("Is Subscribed? ", this.classList.contains('is-subscribed'));
        return this.classList.contains('is-subscribed');
    }

    isNextDiscount(index) {
        // console.log("Is next discount? ", this.stagesTotal[index].classList.contains('discount'));
        return this.stagesTotal[index].classList.contains('discount');
    }

    // Reset the quiz to initial state
    goToStage(index, skippedEmail) {
        // console.log("Index", index);

        // Reset subscription state and wipe cached selections when restarting quiz
        if(index === 0) {
            this.classList.remove('is-subscribed');

            this.selectedCollectionHandle = null;
            this.selectedColorOption = null;
            this.selectedAnswerTags = [];
            this.selectedRecipient = null;
            this.selectedOccasion = null; 
            this.selectedDelivery = null;

            sessionStorage.removeItem('is_subscribed');
            sessionStorage.removeItem('quiz-funnel-restore-final');
            sessionStorage.removeItem('quiz-funnel-restore-final-expires');
            sessionStorage.removeItem('quiz-funnel-customer-form-submitted');

            sessionStorage.removeItem('quiz-collection-handle');
            sessionStorage.removeItem('quiz-color-option');
            sessionStorage.removeItem('quiz-answer-tags');
            sessionStorage.removeItem('quiz-funnel-stage');
            sessionStorage.removeItem('quiz-recipient-handle');
            sessionStorage.removeItem('quiz-occasion-handle');
            sessionStorage.removeItem('quiz-delivery-handle');

            this.syncCustomerTagsInput();

            // Cleanup URL query parameters entirely
            const url = new URL(window.location);
            if (url.search !== '') {
                window.history.replaceState({}, '', url.pathname + url.hash);
            }
        }

        this.setAttribute('data-current-stage', index);
        this.updateProgressTracking();
        this.toggleStage(index);
    }

    getCurrentStage() {
        return Number(this.getAttribute('data-current-stage'));
    }
}

if(!customElements.get('quiz-funnel')) customElements.define('quiz-funnel', QuizFunnel);